import { render, staticRenderFns } from "./FaqLearningSuggestions.vue?vue&type=template&id=c88953e2&scoped=true"
import script from "./FaqLearningSuggestions.vue?vue&type=script&lang=js"
export * from "./FaqLearningSuggestions.vue?vue&type=script&lang=js"
import style0 from "./FaqLearningSuggestions.vue?vue&type=style&index=0&id=c88953e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88953e2",
  null
  
)

export default component.exports